// 防抖
export function debounce(fn, delay) {
	let timeout1 = null
	let flag = true
	return function() {
		clearTimeout(timeout1)
		if (flag) {
			fn.apply(this, arguments)
			flag = false
		}
		timeout1 = setTimeout(() => {
			flag = true
		}, delay)
	}
}
// 节流
export function throttle(fn, delay) {
	let firstTime = true
	let timeout2 = null
	console.log(this)
	return function(...args) {
		if (firstTime) {
			// 第一次加载
			console.log(this)
			fn.apply(this, args)
			return firstTime = false
		}
		if (timeout2) {
			// 定时器正在执行中，跳过
			return
		}
		timeout2 = setTimeout(() => {
			clearTimeout(timeout2)
			timeout2 = null
			fn.apply(this, args)
		}, delay)
	}
}
